import { gql } from '@apollo/client';

export const FarmColumnsFragment = gql`
  fragment FarmColumnFields on Farm {
    id
    name
    team {
      id
      name
    }
    updatedAt
    objectUpdatedAt
    owner {
      id
      firstName
      lastName
      email
    }
    tags
    hasValidSubscription
    isArchived
    isLocked
    allowedActions {
      canEdit
    }
  }
`;
